// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var findReplaceStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match': {
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-border-radius-100, 3px)",
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    boxShadow: "var(--ds-shadow-raised, 0 1px 1px 0 rgba(9, 30, 66, 0.25), 0 0 1px 0 rgba(9, 30, 66, 0.31))".concat(", inset 0 0 0 1px ", "var(--ds-border-input, #8590A2)")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.selected-search-match': {
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var findReplaceStylesNew = css({
  /** Text match styles */

  /** Light mode */

  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-text': {
    borderRadius: "var(--ds-space-050, 4px)",
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #E774BB)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtler, #FDD0EC)", "\n\t\t"),
    // we need to use !important here as we need to override inline selection styles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)".concat(" !important"),
    color: "var(--ds-text, #172B4D)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-text.selected-search-match': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #E774BB)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)", "\n\t\t"),
    // we need to use !important here as we need to override inline selection styles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)".concat(" !important")
  },
  /** Dark mode */

  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-text.search-match-dark': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-pressed, #50253F)", "\n\t\t"),
    // we need to use !important here as we need to override inline selection styles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #50253F)".concat(" !important"),
    color: "var(--ds-text-inverse, #FFFFFF)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-text.selected-search-match.search-match-dark': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-hovered, #943D73)", "\n\t\t"),
    // we need to use !important here as we need to override inline selection styles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)".concat(" !important")
  },
  /** Block match styles */

  /** Light mode */

  /** Without node selection */
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #E774BB)", ",\n\t\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtler, #FDD0EC)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0px 0px 0px 4px ".concat("var(--ds-background-accent-magenta-subtler, #FDD0EC)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)")
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-block-selected': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #E774BB)", ",\n\t\t\tinset 0 0 0 4px ", "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0px 0px 0px 4px ".concat("var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)")
    }
  },
  /** With node selection */
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.ak-editor-selected-node': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #E774BB)", ",\n\t\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtler, #FDD0EC)", ",\n\t\t\t0 0 0 1px ", "var(--ds-border-selected, #0C66E4)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #0C66E4)", ", 0px 0px 0px 4px ", "var(--ds-background-accent-magenta-subtler, #FDD0EC)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)")
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-block-selected.ak-editor-selected-node': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #E774BB)", ",\n\t\t\tinset 0 0 0 4px ", "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)", ",\n\t\t\t0 0 0 1px ", "var(--ds-border-selected, #0C66E4)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #0C66E4)", ", 0px 0px 0px 4px ", "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)")
    }
  },
  /** Dark mode */
  /** Without node selection */
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-dark': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-pressed, #50253F)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0px 0px 0px 4px ".concat("var(--ds-background-accent-magenta-bolder-pressed, #50253F)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-bolder, #AE4787)")
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-block-selected.search-match-dark': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\t\tinset 0 0 0 4px ", "var(--ds-background-accent-magenta-bolder-hovered, #943D73)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0px 0px 0px 4px ".concat("var(--ds-background-accent-magenta-bolder-hovered, #943D73)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-bolder, #AE4787)")
    }
  },
  /** With node selection */
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-dark.ak-editor-selected-node': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-pressed, #50253F)", ",\n\t\t\t0 0 0 1px ", "var(--ds-border-selected, #0C66E4)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #0C66E4)", ", 0px 0px 0px 4px ", "var(--ds-background-accent-magenta-bolder-pressed, #50253F)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-bolder, #AE4787)")
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-block-selected.search-match-dark.ak-editor-selected-node': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\t\tinset 0 0 0 4px ", "var(--ds-background-accent-magenta-bolder-hovered, #943D73)", ",\n\t\t\t0 0 0 1px ", "var(--ds-border-selected, #0C66E4)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #0C66E4)", ", 0px 0px 0px 4px ", "var(--ds-background-accent-magenta-bolder-hovered, #943D73)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-bolder, #AE4787)")
    }
  },
  /** Expand title match styles */

  /** Light mode */

  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-expand-title > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
    borderRadius: "var(--ds-space-050, 4px)",
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #E774BB)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtler, #FDD0EC)", "\n\t\t"),
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-input': {
      color: "var(--ds-text, #172B4D)"
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-expand-title.selected-search-match > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #E774BB)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)", "\n\t\t"),
    backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"
  },
  /** Dark mode */

  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-expand-title.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-pressed, #50253F)", "\n\t\t"),
    backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-input': {
      color: "var(--ds-text-inverse, #FFFFFF)"
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-expand-title.selected-search-match.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-hovered, #943D73)", "\n\t\t"),
    backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
  }
});